export class User {
  id?: string;
  name: string;
  email: string;
  disabled: boolean;
}
